import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HiChat, HiCube, HiHome, HiUsers, HiUpload, HiMail, HiLightBulb, HiSparkles, HiGift, HiSupport, HiChartBar, HiCollection, HiBell, HiPhotograph, HiLightningBolt, HiMoon, HiViewGrid } from 'react-icons/hi';

import { BsPatchQuestionFill } from "react-icons/bs";
import Dashboard from './views/dashboard';
import Feedback from './views/feedback';
import Faq from './views/faq';
import Users from './views/users';
import Module from './views/module';
import ModuleGroupings from './views/moduleGroupings';
import OnboardingQuiz from './views/onboardingQuiz';
import Chapters from './views/chapters';
import LessonPage from './views/lesson';
import LessonContent from './views/lessonContent';
import Quiz from './views/quiz';
import { FaCoins, FaAward } from "react-icons/fa";
//import { HiTrophy } from "react-icons/hi";
import KarmaCoins from './views/karmaCoins/index';
import Achievement from './views/achievement/index';
import Leaderboard from './views/leaderboard/index';
// import PrivacyPolicy from "./views/privacypolicy";
// import TermsAndCondition from "./views/termsAndCondition";
import ResetPassword from "./views/resetpassword";
import ExpireToken from "./views/expiretoken";
import UploadImage from "./views/uploadImage";
import EmailLeads from './views/emailLeads';
import HelpSupportRequests from './views/helpSupportRequests';
import DailyWisdom from './views/dailyWisdom';
import HinduFestivals from './views/hinduFestivals';
import GiftCards from './views/giftCards';
import Notifications from './views/notifications';
import DashboardFestivalBanner from './views/dashboardFestivalBanner';
import PracticeModules from './views/practice/modules';
import PracticeUnits from './views/practice/units';
import PracticeLessons from './views/practice/lessons';
import PracticeQuiz from './views/practice/quiz';
import MeditationMainCategories from './views/meditation/mainCategories';
import MeditationProgramCategories from './views/meditation/programCategories';
import MeditationSessions from './views/meditation/sessions';
import ForYouDashboardConfig from './views/forYouDashboard';
import MeditationAchievements from './views/meditation/achievements';
import ComingSoonTab from './views/appDashboard/comingSoon';
import FeaturedCards from './views/appDashboard/featured';

const routes = [
  {
    name: 'Dashboard',
    layout: '/',
    path: 'dashboard',
    icon: HiHome,
    component: Dashboard,
  },

  // {
  //   name: 'Quiz',
  //   layout: '/',
  //   path: 'quiz',
  //   icon: BsPatchQuestionFill ,
  //   component: Quiz,
  // },
  {
    name: 'Users',
    layout: '/',
    path: 'users',
    icon: HiUsers,
    component: Users,
  },
 

  {
    name: 'Module',
    layout: '/',
    path: 'module',
    icon: HiCube,
    component: Module,
  },
  {
    name: 'Practice',
    layout: '/',
    path: 'practice',
    icon: HiLightningBolt,
    component: PracticeModules,
  },
  {
    name: 'Meditation',
    layout: '/',
    path: 'meditation',
    icon: HiMoon,
    component: MeditationMainCategories,
  },
  {
    name: 'App Dashboard',
    layout: '/',
    path: 'app-dashboard',
    icon: HiViewGrid,
    component: FeaturedCards,
  },
  {
    name: 'Festival Banner',
    layout: '/',
    path: 'festival-banner',
    icon: HiPhotograph,
    component: DashboardFestivalBanner,
  },
  {
    name: 'Onboarding Quiz',
    layout: '/',
    path: 'onboarding-quiz',
    icon: HiCollection,
    component: OnboardingQuiz,
  },
  {
    name: 'Karma Coins Rules',
    layout: "/",
    path: "karma-coins-rules",
    icon: FaCoins,
    component: KarmaCoins,
  },
  {
    name: 'Achievement',
    layout: "/",
    path: "achievement",
    icon: FaAward,
    component: Achievement,
  },
  {
    name: 'Leaderboard',
    layout: "/",
    path: "leaderboard",
    icon: HiChartBar,
    component: Leaderboard,
  },
  {
    name: 'Email List',
    layout: '/',
    path: 'email-leads',
    icon: HiMail,
    component: EmailLeads,
  },
  {
    name: 'Help and Support requests',
    layout: '/',
    path: 'help-support-requests',
    icon: HiSupport,
    component: HelpSupportRequests,
  },
  {
    name: 'Daily Wisdom',
    layout: '/',
    path: 'daily-wisdom',
    icon: HiLightBulb,
    component: DailyWisdom,
  },
  {
    name: 'Hindu Festivals',
    layout: '/',
    path: 'hindu-festivals',
    icon: HiSparkles,
    component: HinduFestivals,
  },
  {
    name: 'Gift Cards',
    layout: '/',
    path: 'gift-cards',
    icon: HiGift,
    component: GiftCards,
  },
  {
    name: 'Notifications',
    layout: '/',
    path: 'notifications',
    icon: HiBell,
    component: Notifications,
  },
  {
    name: 'FAQ',
    layout: '/',
    path: 'faq',
    icon: BsPatchQuestionFill,
    component: Faq,
  },
  {
    name: 'Feedback',
    layout: '/',
    path: 'feedback',
    icon: HiChat,
    component: Feedback,
  },
  {
    name: 'Upload Media',
    layout: '/',
    path: 'upload-image',
    icon: HiUpload,
    component: UploadImage,
  },



];

const AppRoutes = () => {
  return (
    <Routes>
      {routes.filter((route) => route.path !== 'app-dashboard').map((route) => {
        const Component = route.component;
        return (
          <Route
            key={route.path}
            path={route.path === 'dashboard'
              ? '/'
              : `/${route.path}`}
            element={<Component />}
          />
        );
      })}




      {/* <Route path="/privacypolicy" element={<PrivacyPolicy />} />
  <Route path="/terms-and-condition" element={<TermsAndCondition />} /> */}
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/expire-token" element={<ExpireToken />} />

      <Route path="/practice/modules/:moduleId/units" element={<PracticeUnits />} />
      <Route path="/practice/modules/:moduleId/units/:unitId/lessons" element={<PracticeLessons />} />
      <Route path="/practice/modules/:moduleId/units/:unitId/lessons/:lessonId/quiz" element={<PracticeQuiz />} />

      <Route path="/app-dashboard" element={<Navigate to="/app-dashboard/featured" replace />} />
      <Route path="/app-dashboard/coming-soon" element={<ComingSoonTab />} />
      <Route path="/app-dashboard/featured" element={<FeaturedCards />} />
      <Route path="/app-dashboard/shorts" element={<Navigate to="/app-dashboard/coming-soon" replace />} />

      <Route path="/meditation/for-you-dashboard" element={<ForYouDashboardConfig />} />
      <Route path="/meditation/achievements" element={<MeditationAchievements />} />
      <Route path="/meditation/program-categories" element={<MeditationProgramCategories />} />
      <Route path="/meditation/sessions" element={<MeditationSessions />} />
      <Route path="/for-you-dashboard" element={<Navigate to="/meditation/for-you-dashboard" replace />} />

      <Route path="/module/groupings" element={<ModuleGroupings />} />
      <Route path="/module-groupings" element={<Navigate to="/module/groupings" replace />} />
      <Route path="/module/:moduleId/chapters" element={<Chapters />} />
      <Route path="/module/:moduleId/chapters/:chapterId/lessons" element={<LessonPage />} />
      <Route path="/module/:moduleId/chapters/:chapterId/lesson/:lessonId" element={<LessonContent />} />
      <Route path="/module/:moduleId/chapters/:chapterId/lesson/:lessonId/content/:contentId/quiz" element={<Quiz />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
export { routes };

